import { useResourcesStore } from '@/store/modules/resources'

const defaultLogoSvg = `<?xml version="1.0" encoding="UTF-8" standalone="no"?>
<svg width="58.976822" height="61.550301" viewBox="0 0 58.976822 61.5503" version="1.1" id="svg2" xmlns="http://www.w3.org/2000/svg">
  <g fill="#caff01" transform="matrix(0.69243971,0,0,0.69243971,-5.1330706,-3.8479092)">
    <path d="M 65.309,5.5586 C 60.9535,5.613287 56.6293,6.15235 52.418,7.1524 42.051,9.6212 32.359,14.8946 24.551,22.6994 8.977,38.3044 3.477,61.3794 10.289,82.4764 c 0.0039,0.01953 0.01172,0.03516 0.01563,0.05469 0.06641,0.20312 0.16016,0.39844 0.26953,0.58203 0.02734,0.03906 0.05078,0.07813 0.07813,0.11719 0.11328,0.17188 0.25,0.33203 0.40234,0.47266 0.02344,0.02344 0.05078,0.04297 0.08203,0.06641 0.16406,0.14844 0.34766,0.27344 0.54688,0.37891 h 0.0039 c 0.12891,0.06641 0.26172,0.12109 0.39844,0.16797 10.75,3.4883 22.262,3.8398 33.156,1.0039 1.4844,-0.38672 2.375,-1.9023 1.9922,-3.3867 -0.38672,-1.4844 -1.9023,-2.375 -3.3867,-1.9883 -1.5352,0.39844 -3.082,0.72656 -4.6367,0.98828 -3.125,-5.082 -6.9297,-9.8828 -11.273,-14.234 -4.3438,-4.3438 -9.1641,-8.1641 -14.242,-11.293 1.793,-10.727 6.8477,-20.828 14.793,-28.793 7.9609,-7.9453 18.055,-12.996 28.773,-14.785 3.1211,5.0781 6.9336,9.8867 11.273,14.23 4.3477,4.3477 9.1484,8.1641 14.23,11.289 -0.51172,3.0664 -1.2891,6.0938 -2.3398,9.0508 l 0.0039,0.0039 c -0.51563,1.4414 0.23828,3.0312 1.6797,3.5469 1.4453,0.51172 3.0273,-0.24219 3.543,-1.6836 4.3516,-12.242 4.5273,-25.598 0.51562,-38.012 C 86.1593,10.23 86.15147,10.21047 86.13976,10.18703 86.11242,10.10109 86.07726,10.01906 86.0382,9.93703 85.99523,9.851092 85.95226,9.76515 85.90148,9.68312 85.86242,9.616714 85.82335,9.55031 85.77648,9.48781 85.75304,9.452654 85.72961,9.417498 85.70226,9.38625 85.67882,9.355 85.65148,9.327656 85.62804,9.296406 85.59288,9.257343 85.55773,9.222187 85.52257,9.183126 85.51867,9.179216 85.51085,9.171407 85.50694,9.167501 85.44835,9.108907 85.38975,9.050311 85.32725,8.995621 85.25694,8.937027 85.18663,8.882341 85.11241,8.831561 c -0.07422,-0.05078 -0.15234,-0.10156 -0.23047,-0.14844 -0.0039,0 -0.0078,0 -0.0078,-0.00391 C 84.71789,8.593273 84.55383,8.522961 84.38586,8.468271 84.29602,8.440927 84.21008,8.409677 84.12024,8.382333 h -0.0039 -0.0078 c -6.1797,-1.9766 -12.523,-2.9023 -18.797,-2.8203 z m 0.97656,5.5391 c 5.0078,0.02344 10.062,0.75391 15.012,2.2188 1.7188,5.832 2.4297,11.863 2.1367,17.848 -3.8789,-2.5977 -7.5898,-5.6445 -10.984,-9.043 -3.3906,-3.3906 -6.4219,-7.0859 -9.0156,-10.957 0.94922,-0.04687 1.8984,-0.07031 2.8555,-0.06641 z m -4.9492,19.141 h 0.0039 c -0.65234,0.05469 -1.2617,0.33984 -1.7266,0.80469 l -2.0977,2.1055 -2.0625,-2.0625 c -0.52344,-0.51953 -1.2344,-0.80859 -1.9688,-0.80469 -0.73828,-0.0039 -1.4453,0.28516 -1.9688,0.80469 -0.52734,0.51953 -0.82031,1.2305 -0.82031,1.9688 0,0.73828 0.29297,1.4492 0.82031,1.9688 l 2.0625,2.0625 -5.3477,5.3555 -2.0625,-2.0664 -0.0039,-0.0039 c -0.52344,-0.51562 -1.2305,-0.80078 -1.9688,-0.79688 -0.73437,-0.0039 -1.4453,0.28125 -1.9688,0.79688 -0.52344,0.52344 -0.82031,1.2305 -0.82031,1.9727 0,0.73828 0.29688,1.4453 0.82031,1.9688 l 2.0664,2.0664 -5.3594,5.3594 -2.0547,-2.0547 c -0.52344,-0.52734 -1.2305,-0.82031 -1.9727,-0.82031 -0.72656,0 -1.4258,0.28516 -1.9453,0.79688 -0.52344,0.52344 -0.82031,1.2305 -0.82031,1.9688 0,0.73828 0.29688,1.4492 0.82031,1.9688 l 2.0547,2.0625 -2.1172,2.1211 h 0.0039 c -1.0781,1.082 -1.0781,2.832 0,3.918 0.51953,0.52344 1.2266,0.81641 1.9648,0.81641 0.73828,0 1.4453,-0.29297 1.9648,-0.81641 l 2.1055,-2.1055 2.0625,2.0625 c 0.51953,0.51953 1.2305,0.81641 1.9688,0.81641 0.73438,0 1.4453,-0.29688 1.9648,-0.81641 1.0781,-1.0859 1.0781,-2.8359 0,-3.918 l -2.0742,-2.0664 5.3672,-5.3672 2.0625,2.0625 c 0.51953,0.52344 1.2266,0.81641 1.9648,0.81641 0.73828,0 1.4453,-0.29297 1.9688,-0.81641 1.0742,-1.082 1.0742,-2.832 0,-3.918 l -2.0664,-2.0742 5.3594,-5.3594 2.0625,2.0625 h -0.0039 c 0.52344,0.52734 1.2305,0.82031 1.9727,0.82031 0.73828,0 1.4453,-0.29297 1.9688,-0.82031 0.52344,-0.51953 0.81641,-1.2266 0.81641,-1.9688 0,-0.73828 -0.29297,-1.4453 -0.81641,-1.9688 l -2.0625,-2.0625 2.0977,-2.0977 c 0.52734,-0.52344 0.82031,-1.2305 0.82031,-1.9688 0,-0.7383 -0.29297,-1.4492 -0.82031,-1.9688 -0.58203,-0.58203 -1.3906,-0.87891 -2.2109,-0.80469 z m 9.207,20.102 c -5.7109,0 -10.922,2.1914 -14.844,5.7734 l 0.0039,-0.0039 c -0.14062,0.10156 -0.27344,0.21484 -0.39062,0.33594 -0.03516,0.03906 -0.06641,0.08203 -0.09766,0.12109 -4.1367,4.0117 -6.7109,9.6211 -6.7109,15.812 0,6.25 2.6211,11.91 6.8242,15.934 0.0078,0.0078 0.01563,0.01563 0.02344,0.02344 3.9609,3.7812 9.3164,6.1094 15.195,6.1094 5.7383,0 10.98,-2.2148 14.906,-5.8359 v -0.0039 c 0.11719,-0.08984 0.22656,-0.1875 0.32422,-0.29688 0.03906,-0.03516 0.07422,-0.07422 0.10938,-0.11328 4.1289,-4.0156 6.6992,-9.625 6.6992,-15.812 0,-6.168 -2.5547,-11.754 -6.6562,-15.762 -0.04688,-0.05859 -0.09766,-0.11719 -0.15234,-0.17188 -0.11328,-0.11719 -0.23438,-0.22656 -0.36719,-0.32031 -3.9258,-3.5938 -9.1445,-5.7891 -14.863,-5.7891 z m 0,5.5547 c 3.4062,0 6.5625,1.0234 9.1836,2.7773 -3.082,3.875 -4.7969,8.6992 -4.7969,13.711 0,5.0195 1.707,9.8477 4.7891,13.727 -2.6211,1.7578 -5.7734,2.7773 -9.1797,2.7773 -3.4023,0 -6.5586,-1.0234 -9.1797,-2.7773 3.082,-3.8789 4.7891,-8.7109 4.7891,-13.727 0,-5.0156 -1.7031,-9.8438 -4.7852,-13.719 2.6172,-1.75 5.7734,-2.7656 9.1719,-2.7656 z m -57.512,5.6953 c 3.875,2.5938 7.5742,5.6328 10.965,9.0273 3.3945,3.3984 6.4453,7.0977 9.043,10.977 -6.0039,0.29297 -12.043,-0.42188 -17.863,-2.1445 -1.7383,-5.8906 -2.4336,-11.926 -2.1445,-17.859 z m 44.289,0.91797 c 2.1133,2.8281 3.2773,6.2852 3.2773,9.875 0,3.5898 -1.1641,7.0469 -3.2812,9.8789 -2.0508,-2.75 -3.2617,-6.168 -3.2617,-9.8789 0,-3.7148 1.2148,-7.125 3.2656,-9.875 z m 26.453,0.01172 c 2.0469,2.7461 3.2539,6.1562 3.2539,9.8633 0,3.7109 -1.2109,7.1289 -3.2617,9.8789 -2.1172,-2.832 -3.2812,-6.2891 -3.2812,-9.8789 0,-3.582 1.1719,-7.0352 3.2891,-9.8633 z" /></g>
</svg>`

const defaultLogoUrl = `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(defaultLogoSvg).replace(/'/g, '%27').replace(/"/g, '%22')}`

export interface LogoData {
  context?: string
  background?: [number, number, number] | string
  cornerRadius?: number
  width?: number
  height?: number
}

const logoCache = new Map<string, string>()

export async function useBrandLogo(logoData?: LogoData): Promise<string> {
  const resourcesStore = useResourcesStore()
  const context = logoData?.context?.toLowerCase()
  const width = logoData?.width ?? 320
  const height = logoData?.height ?? 180
  const cornerRadius = logoData?.cornerRadius ?? 24

  const bgArray = logoData?.background
  const isRgbArray = Array.isArray(bgArray) && bgArray.length === 3
  const bgColor = isRgbArray
    ? `rgb(${bgArray[0]}, ${bgArray[1]}, ${bgArray[2]})`
    : typeof bgArray === 'string'
      ? bgArray
      : 'rgb(255,255,255)'

  const cacheKey = JSON.stringify({ context, bgColor, cornerRadius, width, height })

  if (logoCache.has(cacheKey)) {
    return logoCache.get(cacheKey)!
  }

  // pick logo SVG content from store
  let svgContent: string | undefined
  if (context) {
    svgContent = resourcesStore.getBannerSvg(`${context}.svg`) || resourcesStore.getIconSvg(`${context}.svg`)
  }

  let logoUrl: string
  if (!svgContent) {
    // fallback to default logo
    logoUrl = defaultLogoUrl
  } else {
    // convert inline SVG string to a data URL
    const encoded = encodeURIComponent(svgContent)
      .replace(/'/g, '%27')
      .replace(/"/g, '%22')
    logoUrl = `data:image/svg+xml;charset=UTF-8,${encoded}`
  }

  return new Promise((resolve) => {
    const img = new Image()
    img.crossOrigin = 'anonymous'
    img.onload = () => {
      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d')!
      canvas.width = width
      canvas.height = height

      ctx.clearRect(0, 0, width, height)

      function drawRoundedRect(x: number, y: number, w: number, h: number, r: number) {
        ctx.beginPath()
        ctx.moveTo(x + r, y)
        ctx.lineTo(x + w - r, y)
        ctx.quadraticCurveTo(x + w, y, x + w, y + r)
        ctx.lineTo(x + w, y + h - r)
        ctx.quadraticCurveTo(x + w, y + h, x + w - r, y + h)
        ctx.lineTo(x + r, y + h)
        ctx.quadraticCurveTo(x, y + h, x, y + h - r)
        ctx.lineTo(x, y + r)
        ctx.quadraticCurveTo(x, y, x + r, y)
        ctx.closePath()
      }

      ctx.save()
      drawRoundedRect(0, 0, width, height, cornerRadius)
      ctx.clip()
      ctx.fillStyle = bgColor
      ctx.fillRect(0, 0, width, height)
      ctx.restore()

      const padding = 0
      const availableW = width * (1 - padding)
      const availableH = height * (1 - padding)
      const scale = Math.min(availableW / img.width, availableH / img.height)
      const w = img.width * scale
      const h = img.height * scale
      const x = (width - w) / 2
      const y = (height - h) / 2

      ctx.drawImage(img, x, y, w, h)

      const dataUrl = canvas.toDataURL('image/png')
      logoCache.set(cacheKey, dataUrl)
      resolve(dataUrl)
    }

    img.onerror = (err) => {
      console.error('❌ Failed to load logo image:', logoUrl, err)
      resolve(logoUrl)
    }

    img.src = logoUrl
  })
}